import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import BuildPlanTab from './BuildPlanTab';

interface BuildTabsProps {
  initialProject?: string;
  initialAnchor?: string;
}

const BuildTabs = ({ initialProject, initialAnchor }: BuildTabsProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  
  const [activeTab, setActiveTab] = useState<string>(() => {
    // Priority: URL > localStorage > default
    const fromUrl = searchParams.get('tab');
    if (fromUrl) return fromUrl;
    const saved = localStorage.getItem('build-active-tab');
    return saved || 'build-plan';
  });

  // Persist tab selection to localStorage + URL
  useEffect(() => {
    localStorage.setItem('build-active-tab', activeTab);
    // Only set URL param if not default tab
    if (activeTab !== 'build-plan') {
      setSearchParams({ tab: activeTab }, { replace: true });
    } else {
      // Remove tab param if default
      const newParams = new URLSearchParams(searchParams);
      newParams.delete('tab');
      setSearchParams(newParams, { replace: true });
    }
    if (import.meta.env.DEV) {
      console.debug('[BuildTabs] Active tab changed:', activeTab);
    }
  }, [activeTab, setSearchParams, searchParams]);

  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">

      <TabsContent value="build-plan" className="mt-6">
        <BuildPlanTab 
          initialProject={initialProject}
          initialAnchor={initialAnchor}
        />
      </TabsContent>

      {/* Future tab contents will be added here */}
    </Tabs>
  );
};

export default BuildTabs;
